import React from 'react';
import { CheckOffset } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { WarrantyItem, WarrantyList } from './styled';
export function WarrantyInformation({ items }) {
    return (React.createElement(WarrantyList, null, items.map((item) => (React.createElement(WarrantyItem, { key: item },
        React.createElement(SVGIcon, { type: CheckOffset, size: ICON_SIZE.s }),
        item)))));
}
